import slick from 'jquery_version/slick.js';
import 'svg.js';
import 'jquery.easing.1.3.js';;
import 'jquery.mCustomScrollbar.concat.min.js';
// import 'jquery_version/fullpage.js';
import 'scrolloverflow.min.js';
import 'jquery_version/jquery.validate.min.js';
import { event } from 'jquery';


$(document).ready(function () {
  $('body').addClass('loading');

  $("html,body").animate({
    scrollTop: $(this).scrollTop() - 1
  }, 10);

  /* ==========================================================================
                * ALL
    ==========================================================================*/
  var $window = $(window);
  var windowHeight = $(window).height();
  var windowWidth = $(window).width();
  var footerHeight = $('footer').height();
 /* ==========================================================================
                * 鼠標
    ==========================================================================*/
    // $(document).mousemove(function(e){
    //   $('.curcil').css(
    //     {
    //       left: e.pageX,
    //       top: e.pageY - scrollTop
    //     }
    //   )
    // })
    // $('a,input,select,textarea,label').mouseenter(function(e){
    //   $('.curcil').css(
    //     {
    //       opacity: 0
    //     }
    //   )
    // })
    // $('a,input,select,textarea,label').mouseleave(function(e){
    //   $('.curcil').css(
    //     {
    //       opacity: 1
    //     }
    //   )
    // })

 
  /* ==========================================================================
                * slick
    ==========================================================================*/
    var getUrlString = parseInt(location.hash.replace("#" , "")) - 1;

    const $slider = $(".indexPage .banner");
      $slider
          .on('init', () => {
              mouseWheel($slider)
          })
          .slick({
              dots: false,
              infinite: true,
              speed: 1000,
              cssEase: 'ease',
              autoplay: false,
              slidesToShow: 1,
              slidesToScroll: 1,
              fade:true,
              slickGoTo: 2,
          })
          .slick('slickGoTo', getUrlString);
      function mouseWheel($slider) {
          $(window).on('wheel', { $slider: $slider }, mouseWheelHandler)
      }
      function mouseWheelHandler(event) {
          // event.preventDefault()
          const $slider = event.data.$slider
          const delta = event.originalEvent.deltaY
          if(delta > 0) {
              $slider.slick('slickNext')
          }
          else {
              $slider.slick('slickPrev')
          }
      }

      // $('.nav_box a').on('click',function(){
      //   setTimeout(function()
      //   {
      //     window.location.reload();
      //   },100)
      // })
/* ==========================================================================
                  * resize
      ==========================================================================*/
      var windowHeight = $(window).height();
      var miniHeight = windowHeight - $('footer').outerHeight();
        $('main').css({
          "min-height":miniHeight + "px"
        });

      $(window).on('resize', function(event) {
        var windowHeight = $(window).height();
        var miniHeight = windowHeight - $('footer').outerHeight();
        
        $('main').css({
          "min-height":miniHeight + "px"
        });

        if($(this).width() > 980){
            $('body,html,footer').removeAttr("style");
            $('.header_box').removeClass('open').removeAttr('style');
            $('.nav_box').removeAttr("style");
            $('.hamburger-menu').removeClass('animate').removeAttr("style");
        }

      });
      /* ==========================================================================
                * header-menu
    ==========================================================================*/
    $('.menu-wrapper').on('click', function() {
      if (!$('.hamburger-menu').hasClass('animate')) {
          $('.hamburger-menu').addClass('animate');
          $('.hamburger-menu').removeClass('colsanimate');
          $('.nav_box').addClass('navop').stop().fadeIn();
          $('.navopbg').addClass('navbgop');
          $('.header_box').addClass('open');
          $('body,html').css({ 'overflow': 'hidden' }).addClass('ops');
          $('footer').css({ 'z-index': '-1' });
          
      } else {
          $('.hamburger-menu').addClass('colsanimate');
          $('.hamburger-menu').removeClass('animate');
          $('footer').removeAttr("style");
          $('.nav_box').removeClass('navop').stop().fadeOut();
          $('.navopbg').removeClass('navbgop');
          $('.header_box').removeClass('open');
          $('body,html,.sub_menu').removeAttr("style").removeClass('ops');
          $('.product_bottom').removeClass('active').removeAttr('style');
      }
  });
  /* ==========================================================================
                * scrollStyle
    ==========================================================================*/
  $('.newsPage .news-list').mCustomScrollbar();


  $(window).on('scroll', function () {
    var scrollTop = $(this).scrollTop();
    var top = $('.top_btn');
    var screenHeight = $(window).height();
    var scrollTop2 = $(this).scrollTop() + (screenHeight / 2);
    if(scrollTop > 99){
      $('.header_show').addClass('chheader');
    } else{
      $('.header_show').removeClass('chheader');
    }
  })
})

